export default __webpack_public_path__ + "img/sagoo/seq/sagoo6_src.webp";